<template>
	<div class="position_page">
		<div class="page_header">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item>岗位列表</el-breadcrumb-item>
			</el-breadcrumb>
			<div class="search_bar">
				<el-input placeholder="请输入岗位名称或企业、子公司名称进行搜索" v-model="keywords" @keyup.enter.native="searchData" clearable class="input-with-select">
					<el-button slot="append" icon="el-icon-search" @click="searchData"></el-button>
				</el-input>
			</div>
			<el-button @click="exportData">导出岗位</el-button>
			<el-upload
				class="position-uploader"
				:action="filePositionUpload"
				:show-file-list="false"
				:headers="Token"
				name="file"
				:on-success="handlePositionUpload"
				accept=".xls,.xlsx">
				<el-button>批量导入岗位</el-button>
			</el-upload>
			<el-upload
				class="position-uploader"
				:action="fileStatusUpload"
				:show-file-list="false"
				:headers="Token"
				name="file"
				:on-success="handleStatusUpload"
				accept=".xls,.xlsx">
				<el-button>导入修改状态</el-button>
			</el-upload>
		</div>
		<el-table :data="dataList" style="width: 100%">
			<el-table-column
				prop="p_company_name"
				label="企业名称">
			</el-table-column>
			<el-table-column
				prop="company_name"
				label="子公司名称">
			</el-table-column>
			<el-table-column
				prop="position_name"
				label="职位名称">
			</el-table-column>
			<el-table-column
				prop="position_number"
				label="需求人数">
			</el-table-column>
			<el-table-column
				prop="intership_time"
				label="实习时间">
			</el-table-column>
			<el-table-column
				prop="position_address"
				label="工作地址">
			</el-table-column>
			<el-table-column width="162" prop="provide_accommodation">
				<template slot="header" slot-scope="scope">
					<el-select v-model="accommodation" placeholder="提供住宿" @change="filterData" clearable>
						<el-option v-for="item in options" :label="item.name" :value="item.id" :key="item.id"></el-option>
					</el-select>
				</template>
				<template slot-scope="scope">
					<span v-text="scope.row.provide_accommodation == 1 ? '是' : '否'"></span>
				</template>
			</el-table-column>
			<el-table-column width="162" prop="is_full">
				<template slot="header" slot-scope="scope">
					<el-select v-model="isFull" placeholder="是否招满" @change="filterDataFull" clearable>
						<el-option label="是" :value=1 key="1"></el-option>
						<el-option label="否" :value=0 key="0"></el-option>
						<el-option label="全部" :value=2 key="2"></el-option>
					</el-select>
				</template>
				<template slot-scope="scope">
					<span v-text="scope.row.is_full == 1 ? '是' : '否'"></span>
				</template>
			</el-table-column>
			<el-table-column
				label="操作">
				<template slot-scope="scope">
					<el-button type="text" size="mini" @click="handleStatus(scope.row.is_full, scope.row.position_id)">修改状态</el-button>
					<el-button type="text" size="mini" @click="handleDelete(scope.row.position_id)">删除岗位</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div v-if="dataList.length !== 0" class="page_container">
			<el-pagination
				background
				layout="prev, pager, next"
				@current-change="getPageList"
				:current-page.sync="page"
				:page-size="page_size"
				:total="total">
			</el-pagination>
		</div>
		<el-dialog title="修改职位状态" :visible.sync="dialogStatus" custom-class="self_dialog">
			<div class="dialog_inner">
				<el-radio v-model="status" :label=0>未招满</el-radio>
				<el-radio v-model="status" :label=1>已招满</el-radio>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogStatus = false">取 消</el-button>
				<el-button type="primary" @click="handleStatusSubmit()">确认修改</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import { host } from '../utils/host.js';
	import { getLocalStorage } from '../utils/localStorage.js';
	import { downloadFile } from '../utils/fn.js';
	export default {
		data() {
			return {
				dialogStatus: false,
				options: [
					{
						name: '是',
						id: 1
					},
					{
						name: '否',
						id: 0
					},
					{
						name: '全部',
						id: 2
					}
				],
				page: 1,
				page_size: 10,
				keywords: '',
				provide_accommodation: null,
				is_full: null,
				is_export: null,
				dataList: [],
				total: 0,
				accommodation: '',
				isFull: '',
				Token: { Token: getLocalStorage()},
				filePositionUpload: host +'/hktopic/position/import',      //职位文件上传接收地址
				status: '',
				positionId: '',
				fileStatusUpload: host + '/hktopic/position/import_change_info'
			}
		},
		created() {
			this.getPositionData();
		},
		methods: {
			getPositionData() {
				this.$http.get('/hktopic/position', {
					params: {
						page: this.page,
						page_size: this.page_size,
						keywords: this.keywords,
						provide_accommodation: this.provide_accommodation,
						is_full: this.is_full,
						is_export: this.is_export
					}
				}).then(res => {
					if (res.data.code == 0) {
						this.dataList = res.data.data.data;
						this.total = res.data.data.total;
					}
				}).catch(err => {
					console.log(err)
				})
			},
			filterData(value) {
				this.page = 1;
				if (value == 2) {
					this.provide_accommodation = null;
				}else {
					this.provide_accommodation = value;
				}
				this.getPositionData();
			},
			filterDataFull(value) {
				this.page = 1;
				if (value == 2) {
					this.is_full = null;
				} else{
					this.is_full = value;
				}
				this.getPositionData();
			},
			searchData() {
				this.page = 1;
				this.getPositionData();
			},
			getPageList(page) {
				this.page = page;
				this.getPositionData();
			},
			handleStatus(status, id) {
				this.dialogStatus = true;
				this.status = status;
				this.positionId = id;
			},
			handleStatusSubmit() {
				this.$http.put(`/hktopic/position/${this.positionId}`, {
					is_full: this.status
				}).then(res => {
					if (res.data.code == 0) {
						this.dialogStatus = false;
						this.$message.success('岗位状态修改成功！');
						this.getPositionData();
					}
				}).catch(err => {
					console.log(err)
				})
			},
			handleDelete(id) {
				this.$confirm('确认删除该岗位?', '系统提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.delete(`/hktopic/position/${id}`).then(res => {
						if (res.data.code == 0) {
							this.$message.success('岗位删除成功！');
							this.getPositionData();
						}
					}).catch(err => {
						console.log(err)
					})
				}).catch(() => {
				
				});
			},
			handlePositionUpload(response) {
				if (response.code == 0) {
					this.$message.success('批量导入成功！');
					this.getPositionData();
				}else {
					this.$message.error('上传失败' + response.message)
				}
			},
			handleStatusUpload(response) {
				if (response.code == 0) {
					this.$message.success('导入状态修改成功！');
					this.getPositionData();
				}else {
					this.$message.error('导入失败' + response.message)
				}
			},
			exportData() {
				this.$http.get('/hktopic/position', {
					params: {
						keywords: this.keywords,
						provide_accommodation: this.provide_accommodation,
						is_full: this.is_full,
						is_export: 1
					},
					responseType: 'blob'
				}).then(res => {
					var D = +new Date();
					downloadFile(res.data, '岗位列表-'+ D +'.xls')
				}).catch(err => {
					console.log(err)
				})
			}
		}
	}
</script>

<style lang="less">
	.position_page{
		.search_bar{
			display: inline-block;
			width: 400px;
			margin-right: 20px;
		}
		.position-uploader{
			display: inline-block;
			margin-left: 20px;
			margin-right: 20px;
		}
	}
</style>
